import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Radio from '@mui/material/Radio';
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { clsx } from 'clsx';
// Resources
import { PickerOption } from '../../core/apiTypes';
import useGlobalStyles from '../hook/useGlobalStyles';

interface RadioButtonGroupProps extends RadioGroupProps {
    title: string;
    titleHidden?: boolean;
    containerClassName?: string;
    options: PickerOption[];
    labelPlacement?: FormControlLabelProps['labelPlacement'];
}

const RadioButtonGroup: FC<RadioButtonGroupProps> = (props): ReactElement => {
    const { title, titleHidden = true, options, containerClassName, labelPlacement = 'end', ...rest } = props;
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    return (
        <FormControl className={clsx(classes.formGroup, containerClassName)}>
            <FormLabel
                id={`radio-buttons-group-${rest.name}`}
                className={titleHidden ? globalClasses.visuallyHidden : undefined}
            >
                {title}
            </FormLabel>
            <RadioGroup
                aria-labelledby={`radio-buttons-group-${rest.name}`}
                {...rest}
                onClick={(event) => {
                    const isRadioClick = (event.target as HTMLElement).tagName === 'INPUT';
                    if (isRadioClick) {
                        rest.onClick?.(event);
                    }
                }}
            >
                {options.map(({ value: optionValue, label, disabled }) => (
                    <FormControlLabel
                        key={optionValue}
                        value={optionValue}
                        control={<Radio color={rest.color as any} />} // TODO: MUI - change the Icons to not use mui icon
                        label={label}
                        labelPlacement={labelPlacement}
                        disabled={disabled}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        formGroup: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'nowrap',
            flexShrink: 0,
        },
    }),
);

export default RadioButtonGroup;
